var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQaFailed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.2C17.6333 22.2 22.2 17.6333 22.2 12C22.2 6.3667 17.6333 1.8 12 1.8C6.3667 1.8 1.8 6.3667 1.8 12C1.8 17.6333 6.3667 22.2 12 22.2ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F43E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.00718L15.9928 7.00004L12 10.9929L8.0071 7.00004L6.99996 8.00718L10.9928 12L6.99996 15.9929L8.0071 17L12 13.0072L15.9928 17L17 15.9929L13.0071 12L17 8.00718Z",
    fill: "#F43E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0071 6.64648L12 10.6393L15.9928 6.64648L17.3535 8.00718L13.3607 12L17.3535 15.9929L15.9928 17.3536L12 13.3607L8.0071 17.3536L6.64641 15.9929L10.6393 12L6.64641 8.00718L8.0071 6.64648ZM7.35351 8.00718L11.3464 12L7.35351 15.9929L8.0071 16.6465L12 12.6536L15.9928 16.6465L16.6464 15.9929L12.6536 12L16.6464 8.00718L15.9928 7.35359L12 11.3464L8.0071 7.35359L7.35351 8.00718Z",
    fill: "#F43E3E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQaFailed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QAFailed.f63c4697.svg";
export { ForwardRef as ReactComponent };